// SPDX-License-Identifier: AGPL-3.0-or-later

export const OFFICIAL_WEB_APP_HOSTS = [
	'chat.nexoriadevelopment.com',
	'web.fluxer.app',
	'web.canary.fluxer.app',
	'fluxer.com',
	'canary.fluxer.com',
] as const;
